import { wrapReducer } from "@client/content/lib/helper";
import { type FailureActionData } from "@client/lib/actions";
import { type ReduxAction } from "@client/types/ReduxAction";
import {
  type CloseTicketSuccessActionData,
  type CreateCommentSuccessActionData,
  type RateSuccessActionData
} from "../MemberHelpdesk/actions";
import { Actions, type GetTicketDataSuccessActionData, type InitSuccessActionData } from "./actions";
import { type TicketDetail } from "./types";

const reducer = (state: TicketDetail.AppState = defaultState, action: ReduxAction<any>): TicketDetail.AppState => {
  switch (action.type) {
    case Actions.InitBegin: {
      return {
        ...state,
        status: "Loading"
      };
    }
    case Actions.InitFailure: {
      return {
        ...state,
        status: "Failed"
      };
    }
    case Actions.InitSuccess: {
      const data = action.data as InitSuccessActionData;

      return {
        ...state,
        status: "Ready",
        isVisibleSecureModal: !!data.obfuscatedEmail,
        obfuscatedEmail: data.obfuscatedEmail,
        error: data.error
      };
    }
    case Actions.CreateUserFeedbackBegin: {
      return {
        ...state,
        error: null,
        status: "Commenting"
      };
    }
    case Actions.CreateUserFeedbackFailure: {
      const { error } = action.data as FailureActionData;
      return {
        ...state,
        error,
        status: "Failed"
      };
    }
    case Actions.CreateUserFeedbackSuccess: {
      const { userTicketFeedbacks } = action.data as RateSuccessActionData;
      return {
        ...state,
        detail: { ...state.detail!, userTicketFeedbacks },
        status: "Ready"
      };
    }
    case Actions.CloseTicketBegin: {
      return {
        ...state,
        error: null,
        status: "Commenting"
      };
    }
    case Actions.CloseTicketFailure: {
      const { error } = action.data as FailureActionData;
      return {
        ...state,
        error,
        status: "Failed"
      };
    }
    case Actions.CloseTicketSuccess: {
      const { ticketDetail } = action.data as CloseTicketSuccessActionData;

      return {
        ...state,
        detail: { ...state.detail!, ticketDetail: ticketDetail },
        status: "Ready"
      };
    }
    case Actions.CreateCommentBegin: {
      return {
        ...state,
        error: null,
        status: "Commenting"
      };
    }
    case Actions.CreateCommentFailure: {
      const { error } = action.data as FailureActionData;
      return {
        ...state,
        error,
        status: "Failed"
      };
    }
    case Actions.CreateCommentSuccess: {
      const detail = action.data as CreateCommentSuccessActionData;
      return {
        ...state,
        detail: detail,
        status: "Ready"
      };
    }
    case Actions.GetTicketDataBegin:
      return {
        ...state,
        status: "Loading"
      };
    case Actions.GetTicketDataFailure:
      return {
        ...state,
        status: "Failed"
      };
    case Actions.GetTicketDataSuccess:
      const data = action.data as GetTicketDataSuccessActionData;
      return {
        ...state,
        status: "Ready",
        ...data,
        isVisibleSecureModal: !data?.detail
      };
    default:
      return state;
  }
};

export const defaultState: TicketDetail.AppState = {
  id: "",
  error: null,
  detail: null,
  canLeaveFeedback: false,
  permalink: "",
  status: "None",
  isVisibleSecureModal: false,
  obfuscatedEmail: null
};
export const previewState: TicketDetail.AppState = {
  ...defaultState,
  detail: {
    attachments: [],
    comments: [],
    feedbackQuestions: [],
    ticketDetail: {
      agentFirstName: "Dummy",
      agentLastName: "Dummy",
      contactEmail: "Dummy",
      contactFirstName: "Dummy",
      contactLastName: "Dummy",
      contactProfilePictureMediaSourceKey: null,
      contactProfilePictureSourceId: null,
      createdOnDate: new Date().toISOString(),
      message: "Dummy",
      number: 11,
      priorityLabel: "Dummy",
      subject: "Dummy",
      ticketId: "",
      ticketStatusKey: "Active",
      ticketStatusName: "Active"
    },
    userTicketFeedbacks: []
  },
  status: "Ready"
};
export default wrapReducer({ defaultState, reducer, previewState });
